module.exports = __webpack_public_path__ + "img/vote_gift.528fc847.png";